import { Box, Divider, Heading, Text, VStack } from "native-base";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import colors from "../../../../constants/colors";
import { StateContext } from "../../../../contexts";
import routes from "../../../../routes";

function SignUpAgencySuccessPage() {
  const state = useContext(StateContext);

  return (
    <VStack
      maxWidth={900}
      width="100%"
      marginTop={50}
      alignSelf="center"
      backgroundColor={colors.white}
      padding={10}
      borderRadius={5}
      space={5}
      alignItems="center">
      <Helmet>
        <title>Registro - ¡Listo! Tu registro ha sido exitoso</title>
      </Helmet>
      <Heading color={colors.secondary} fontSize="xl" textAlign="center">
        ¡Listo! Tu registro ha sido exitoso
      </Heading>
      <Text>Este es tu usuario:</Text>
      <Divider backgroundColor={colors.secondary} height="2px" />
      <VStack
        space={3}
        padding={3}
        borderWidth={1}
        borderColor={colors.secondary}>
        <Heading color={colors.secondary} fontSize="md" textAlign="center">
          Correo electrónico
        </Heading>
        <Heading fontSize="md" textAlign="center">
          {state.user.email}
        </Heading>
      </VStack>
      <Link to={routes.agencyDashboard}>
        <Box
          backgroundColor={colors.primary}
          borderRadius={40}
          paddingX={100}
          paddingY={3}>
          <Text color={colors.white}>Continuar</Text>
        </Box>
      </Link>
    </VStack>
  );
}

export default SignUpAgencySuccessPage;
